<template>
  <v-card flat tile class="plano-workspace grey lighten-4 fill-height d-flex flex-column">
    <!-- ESTADO VACÍO -->
  
    <v-container
      v-if="!hayPlanoSeleccionado"
      class="fill-height d-flex flex-column justify-center align-center"
    >
      <v-icon size="120" color="grey lighten-2">mdi-map-marker-radius-outline</v-icon>
      <div class="text-h5 grey--text text--darken-1 font-weight-light mt-4">
        Selecciona un plano para comenzar
      </div>
      <div class="text-body-2 grey--text mt-2">
        Utiliza el panel de la izquierda para explorar los planos disponibles.
      </div>
    </v-container>

    <template v-else>

      <!-- HUD -->
      <v-sheet
        v-if="!soloPlanos"
        class="action-hud d-flex align-center elevation-3"
        :class="xs ? 'hud-movil rounded-lg pa-1 px-2' : 'rounded-pill ma-4 pa-2 px-4'"
      >
        <div class="d-flex align-center hud-titulo" :class="xs ? 'mr-1' : 'mr-4'">
          <v-icon :left="!xs" :small="xs" color="primary">mdi-image-filter-center-focus</v-icon>
          <span class="text-subtitle-2 font-weight-bold grey--text text--darken-2 text-truncate" :title="selectedPlano.nombre">
            {{ selectedPlano.nombre || "Visualizador" }}
          </span>
        </div>

        <v-divider vertical :class="xs ? 'mx-1' : 'mx-3'"></v-divider>

        <v-btn
          v-if="modo === 1 && puedeEditarPlanos"
          @click="abrirDialogoSeleccionArmario"
          color="primary"
          rounded
          depressed
          small
          :icon="xs"
          :class="xs ? 'mr-1 boton-hud-movil' : 'mr-2 px-4'"
          aria-label="Generar Región"
          title="Generar Región"
        >
          <v-icon :left="!xs" small>mdi-plus-box</v-icon>
          <template v-if="!xs">Generar Región</template>
        </v-btn>

        <v-btn
          v-if="modo === 1 && puedeEditarPlanos"
          @click="modo = 2"
          color="warning"
          outlined
          rounded
          small
          :icon="xs"
          :class="xs ? 'boton-hud-movil' : 'px-4'"
          aria-label="Editar regiones"
          title="Editar regiones"
        >
          <v-icon :left="!xs" small>mdi-pencil</v-icon>
          <template v-if="!xs">Editar regiones</template>
        </v-btn>

        <v-btn
          v-if="modo === 2"
          @click="finalizarEdicion"
          color="success"
          depressed
          rounded
          small
          class="px-4"
        >
          <v-icon left small>mdi-check-circle</v-icon>
          {{ xs ? "Listo" : "Finalizar edición" }}
        </v-btn>

        <v-spacer></v-spacer>

        <v-chip
          v-if="modo === 2 && !xs"
          color="orange lighten-4"
          orange--text
          small
          label
          class="font-weight-bold"
        >
          MODO EDICIÓN ACTIVO
        </v-chip>
      </v-sheet>
      <!-- CONTENEDOR -->
      <div class="plano-viewport flex-grow-1" :class="{ 'plano-viewport-movil': xs }">

        <div
          v-if="imagenParaMostrar"
          ref="planoContainer"
          class="plano-canvas elevation-5"
          :class="{ 'plano-paneando': paneo && paneo.movido, 'plano-con-hud': !soloPlanos }"
          :style="estiloLienzo"
          @click="onCanvasClick"
          @pointerdown="iniciarPaneo"
          @wheel.prevent="onRueda"
        >
  
          <div
            v-for="region in regionesArmarioVisibles"
            :key="`armario-${region.id}`"
            :ref="`region-${getRegionKey(region)}`"
            class="region-box"
            :class="{
              'region-view': modo === 1,
              'region-edit': modo === 2,
              'region-highlight': hayRegionSeleccionada && region.id === regionSeleccionadaId,
              'region-armario': region.tipo_region === 'armario',
              'region-pulse': (hayRegionSeleccionada && region.id === regionSeleccionadaId) || resaltada === getRegionKey(region),
              'region-selected': regionEditando && getRegionKey(region) === getRegionKey(regionEditando),
            }"
            :style="getRegionBoxStyle(region)"
            @click.stop="onRegionClick(region)"
          >
            <div class="region-visual" :style="getRegionVisualStyle(region)">
              <div v-if="modo === 2" class="region-label">Mover/Redimensionar</div>
              <div v-else-if="mostrarNombres" class="etiqueta-region">{{ region.name }}</div>

              <v-btn
                v-if="modo === 2"
                icon
                x-small
                color="white"
                class="delete-region-btn"
                @click.stop="eliminarRegion(region)"
              >
                <v-icon small color="error">mdi-close-circle</v-icon>
              </v-btn>
            </div>
          </div>
          <!-- Armarios marcados con el símbolo de su categoría (sin región) -->
          <v-tooltip v-for="m in marcadoresVisibles" :key="`marcador-${m.id}`" top :disabled="!!arrastreMarcador || mostrarNombres">
            <template v-slot:activator="{ on, attrs }">
              <div
                :ref="`region-${getRegionKey(m)}`"
                class="marcador"
                :class="{
                  'marcador-movible': modo === 2 && puedeEditarPlanos && !modoCrear,
                  'marcador-arrastrando': arrastreMarcador && arrastreMarcador.movido && arrastreMarcador.id === m.id,
                  'region-pulse': (hayRegionSeleccionada && m.id === regionSeleccionadaId) || resaltada === getRegionKey(m),
                }"
                :style="getMarcadorStyle(m)"
                role="button"
                :aria-label="m.name"
                v-bind="attrs"
                v-on="on"
                @pointerdown="iniciarArrastreMarcador(m, $event)"
                @click.stop="onMarcadorClick(m)"
              >
                <SimboloCategoria
                  :icono="categoriaDe(m) ? categoriaDe(m).icono : null"
                  :color="categoriaDe(m) ? categoriaDe(m).color : undefined"
                  :tamano="tamanoDe(m)"
                />
                <span v-if="mostrarNombres" class="etiqueta-marcador">{{ m.name }}</span>
                <span
                  v-if="modo === 2 && puedeEditarPlanos"
                  class="asa-tamano"
                  role="button"
                  :aria-label="`Cambiar tamaño de ${m.name}`"
                  @pointerdown.stop="iniciarArrastreMarcador(m, $event, 'tamano')"
                  @click.stop
                >
                  <v-icon x-small>mdi-arrow-top-left-bottom-right</v-icon>
                </span>
                <v-btn
                  v-if="modo === 2"
                  icon
                  x-small
                  color="white"
                  class="delete-region-btn"
                  :aria-label="`Quitar ${m.name} del plano`"
                  @pointerdown.stop
                  @click.stop="eliminarRegion(m)"
                >
                  <v-icon small color="error">mdi-close-circle</v-icon>
                </v-btn>
              </div>
            </template>
            <span>{{ m.name }}</span>
          </v-tooltip>

          <div
            v-for="region in regionesPlano"
            :key="`plano-${region.id}`"
            :ref="`region-${getRegionKey(region)}`"
            class="region-box"
            :class="{
              'region-view': modo === 1,
              'region-edit': modo === 2,
              'region-highlight': hayRegionSeleccionada && region.id === regionSeleccionadaId,
              'region-plano': region.tipo_region === 'plano',
              'region-pulse': (hayRegionSeleccionada && region.id === regionSeleccionadaId) || resaltada === getRegionKey(region),
              'region-selected': regionEditando && getRegionKey(region) === getRegionKey(regionEditando),
            }"
            :style="getRegionBoxStyle(region)"
            @click.stop="onRegionClick(region)"
          >
            <div class="region-visual">
              <div v-if="modo === 2" class="region-label">Mover/Redimensionar</div>
              <div v-else-if="mostrarNombres" class="etiqueta-region">{{ region.nombre }}</div>

              <v-btn
                v-if="modo === 2"
                icon
                x-small
                color="white"
                class="delete-region-btn"
                @click.stop="eliminarRegion(region)"
              >
                <v-icon small color="error">mdi-close-circle</v-icon>
              </v-btn>
            </div>
          </div>

          <Moveable
            ref="moveable"
            v-if="modo === 2 && moveableTarget"
            :target="moveableTarget"
            :draggable="true"
            :resizable="true"
            :rotatable="true"
            :origin="false"
            :throttle-drag="0"
            :throttle-resize="0"
            :throttle-rotate="0"
            @dragStart="onMoveableDragStart"
            @drag="onMoveableDrag"
            @dragEnd="onMoveableDragEnd"
            @resizeStart="onMoveableResizeStart"
            @resize="onMoveableResize"
            @resizeEnd="onMoveableResizeEnd"
            @rotateStart="onRotateStart"
            @rotate="onRotate"
            @rotateEnd="onRotateEnd"
          />

          <!-- Plano sin nada colocado: qué hacer -->
          <div v-if="planoVacio" class="plano-vacio elevation-2" @click.stop @pointerdown.stop>
            <v-icon size="36" color="primary">mdi-map-marker-question-outline</v-icon>
            <div class="font-weight-bold mt-2">Este plano todavía no tiene armarios</div>
            <template v-if="puedeEditarPlanos">
              <div class="text-caption grey--text text--darken-1 mt-1">Coloca el primero como región o como símbolo.</div>
              <v-btn small color="primary" depressed class="mt-3 text-none" @click="abrirDialogoSeleccionArmario">
                <v-icon left small>mdi-plus-box</v-icon> Colocar un armario
              </v-btn>
            </template>
            <div v-else class="text-caption grey--text text--darken-1 mt-1">Cuando se coloquen, aparecerán aquí.</div>
          </div>

          <!-- Leyenda: pulsar una categoría la oculta o la vuelve a mostrar -->
          <div v-if="leyenda.length" class="plano-leyenda elevation-2" @click.stop @pointerdown.stop @wheel.stop>
            <button type="button" class="leyenda-cabecera" :aria-expanded="String(leyendaAbierta)" @click="leyendaAbierta = !leyendaAbierta">
              <v-icon x-small class="mr-1">mdi-shape-outline</v-icon>
              Leyenda
              <span v-if="categoriasOcultas.length" class="leyenda-ocultas">· {{ categoriasOcultas.length }} oculta{{ categoriasOcultas.length > 1 ? "s" : "" }}</span>
              <v-spacer />
              <v-icon x-small>{{ leyendaAbierta ? "mdi-chevron-down" : "mdi-chevron-up" }}</v-icon>
            </button>
            <template v-if="leyendaAbierta">
              <button
                v-for="item in leyenda"
                :key="item.clave"
                type="button"
                class="leyenda-item"
                :class="{ 'leyenda-oculta': categoriasOcultas.includes(item.clave) }"
                :aria-pressed="String(!categoriasOcultas.includes(item.clave))"
                :title="categoriasOcultas.includes(item.clave) ? 'Mostrar' : 'Ocultar'"
                @click="alternarCategoria(item.clave)"
              >
                <SimboloCategoria :icono="item.icono" :color="item.color" :tamano="14" class="mr-2" />
                <span class="leyenda-nombre">{{ item.nombre }}</span>
                <span class="leyenda-cuenta">{{ item.cuenta }}</span>
              </button>
              <button v-if="categoriasOcultas.length" type="button" class="leyenda-mostrar-todo" @click="categoriasOcultas = []">
                Mostrar todo
              </button>
            </template>
          </div>

          <!-- Controles de vista: buscar, nombres y zoom -->
          <div class="plano-controles elevation-2" @click.stop @pointerdown.stop @wheel.stop>
            <v-menu v-model="buscadorAbierto" offset-y top left :close-on-content-click="false" min-width="260">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small v-bind="attrs" v-on="on" aria-label="Buscar en el plano" title="Buscar en el plano">
                  <v-icon small>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <v-card class="pa-2">
                <v-autocomplete
                  ref="buscador"
                  :items="elementosPlano"
                  item-text="nombre"
                  item-value="clave"
                  label="Buscar armario o subplano"
                  prepend-inner-icon="mdi-magnify"
                  no-data-text="No hay nada con ese nombre en este plano"
                  dense
                  outlined
                  hide-details
                  autofocus
                  @change="enfocarElemento"
                >
                  <template v-slot:item="{ item }">
                    <v-icon small class="mr-2" :color="item.tipo === 'plano' ? 'deep-purple' : 'primary'">
                      {{ item.tipo === "plano" ? "mdi-floor-plan" : "mdi-locker-multiple" }}
                    </v-icon>
                    {{ item.nombre }}
                  </template>
                </v-autocomplete>
              </v-card>
            </v-menu>
            <v-btn
              icon
              small
              :color="mostrarNombres ? 'primary' : undefined"
              :aria-pressed="String(mostrarNombres)"
              aria-label="Mostrar nombres"
              :title="mostrarNombres ? 'Ocultar nombres' : 'Mostrar nombres'"
              @click="cambiarMostrarNombres"
            >
              <v-icon small>{{ mostrarNombres ? "mdi-label" : "mdi-label-outline" }}</v-icon>
            </v-btn>
            <span class="separador-controles"></span>
            <v-btn icon small aria-label="Alejar" title="Alejar" :disabled="zoom <= ZOOM_MIN" @click="zoomEn(1 / PASO_ZOOM)">
              <v-icon small>mdi-magnify-minus-outline</v-icon>
            </v-btn>
            <span class="zoom-valor">{{ Math.round(zoom * 100) }}%</span>
            <v-btn icon small aria-label="Acercar" title="Acercar" :disabled="zoom >= ZOOM_MAX" @click="zoomEn(PASO_ZOOM)">
              <v-icon small>mdi-magnify-plus-outline</v-icon>
            </v-btn>
            <v-btn icon small aria-label="Ver el plano entero" title="Ver el plano entero" :disabled="zoom === 1" @click="reiniciarVista">
              <v-icon small>mdi-fit-to-screen-outline</v-icon>
            </v-btn>
          </div>

        </div>
      </div>
      

      
    </template>

    <!-- DIÁLOGO: Seleccionar destino -->
    <v-dialog v-model="dialogSeleccionarArmario" max-width="560px" scrollable>
      <v-card rounded="xl">
        <v-card-title class="primary white--text">
          <v-icon left color="white">
            {{ tabDestinoRegion === 0 ? "mdi-locker-multiple" : "mdi-floor-plan" }}
          </v-icon>
          {{ tabDestinoRegion === 0 ? "Vincular Armario" : "Vincular Subplano" }}
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogSeleccionarArmario = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <!-- PASO 2: cómo colocar el armario elegido -->
        <v-card-text v-if="armarioPendiente" class="pa-4">
          <div class="d-flex align-center mb-4">
            <v-btn icon small class="mr-2" aria-label="Volver a la lista" @click="armarioPendiente = null">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <span class="text-body-2">
              ¿Cómo quieres colocar <strong>{{ armarioPendiente.name }}</strong> en el plano?
            </span>
          </div>
          <v-row dense>
            <v-col cols="6">
              <v-card outlined class="opcion-colocar pa-4 text-center fill-height" role="button" aria-label="Colocar como región" @click="prepararColocacion(armarioPendiente, false)">
                <v-icon size="40" color="primary">mdi-vector-square</v-icon>
                <div class="font-weight-bold mt-2">Región</div>
                <div class="text-caption grey--text text--darken-1">Rectángulo que puedes mover, redimensionar y girar</div>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card outlined class="opcion-colocar pa-4 text-center fill-height" role="button" aria-label="Colocar como símbolo" @click="prepararColocacion(armarioPendiente, true)">
                <div class="simbolo-opcion">
                  <SimboloCategoria
                    :icono="categoriaDe(armarioPendiente) ? categoriaDe(armarioPendiente).icono : null"
                    :color="categoriaDe(armarioPendiente) ? categoriaDe(armarioPendiente).color : undefined"
                    :tamano="32"
                  />
                </div>
                <div class="font-weight-bold mt-2">Símbolo</div>
                <div class="text-caption grey--text text--darken-1">
                  {{ categoriaDe(armarioPendiente) ? `El de su categoría (${categoriaDe(armarioPendiente).nombre})` : "Un punto (el armario no tiene categoría)" }}
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>

        <template v-else>
        <v-tabs v-model="tabDestinoRegion" grow background-color="grey lighten-4">
          <v-tab>
            <v-icon left small>mdi-locker-multiple</v-icon>
            Armarios
          </v-tab>
          <v-tab>
            <v-icon left small>mdi-floor-plan</v-icon>
            Planos
          </v-tab>
        </v-tabs>

        <v-toolbar flat dense color="grey lighten-4">
          <span class="text-caption grey--text font-weight-bold">
            {{ tabDestinoRegion === 0 ? "SELECCIONA O CREA UN ELEMENTO" : "SELECCIONA UN SUBPLANO" }}
          </span>
          <v-spacer></v-spacer>

          <v-btn
            v-if="tabDestinoRegion === 0 && puedeEditarArmarios"
            small
            color="primary"
            text
            @click="iniciarCreacionArmarioRaiz"
          >
            <v-icon left small>mdi-plus</v-icon>
            Nuevo Raíz
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-0">
          <!-- TAB ARMARIOS -->
          <div v-show="tabDestinoRegion === 0">
            <v-expand-transition>
              <div v-show="creandoArmarioRaiz" class="pa-4 blue lighten-5">
                <v-text-field
                  v-model="nuevoArmario"
                  label="Nombre del nuevo armario"
                  outlined
                  dense
                  hide-details
                  bg-color="white"
                  class="mb-2"
                ></v-text-field>
                <div class="d-flex justify-end">
                  <v-btn x-small text @click="creandoArmarioRaiz = false" class="mr-2">
                    Cancelar
                  </v-btn>
                  <v-btn x-small color="primary" @click="crearArmarioRaiz">
                    Guardar elemento
                  </v-btn>
                </div>
              </div>
            </v-expand-transition>

            <v-list v-if="armariosAplanados.length > 0" class="py-0">
              <v-list-item
                v-for="armario in armariosAplanados"
                :key="armario.id"
                @click="seleccionarArmarioParaRegion(armario)"
                class="border-bottom"
              >
                <v-list-item-content :style="{ paddingLeft: armario.nivel * 20 + 'px' }">
                  <v-list-item-title class="d-flex align-center">
                    <div class="hierarchy-line" v-if="armario.nivel > 0"></div>
                    <v-icon
                      small
                      class="mr-2"
                      :color="armario.children_count > 0 ? 'orange' : 'grey'"
                    >
                      {{ armario.children_count > 0 ? "mdi-folder" : "mdi-circle-medium" }}
                    </v-icon>
                    <span :class="armario.nivel === 0 ? 'font-weight-bold' : ''">
                      {{ armario.name }}
                    </span>
                    <v-chip
                      v-if="armario.adjuntos_count > 0"
                      x-small
                      class="ml-2"
                      color="blue lighten-4"
                      blue--text
                    >
                      {{ armario.adjuntos_count }}
                    </v-chip>
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                  <v-btn
                    icon
                    x-small
                    color="primary"
                    @click.stop="abrirDialogCrearSubNodo(armario)"
                  >
                    <v-icon>mdi-plus-circle-outline</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>

            <div v-else class="pa-8 text-center grey--text">
              No hay elementos disponibles.
            </div>
          </div>

          <!-- TAB PLANOS -->
          <div v-show="tabDestinoRegion === 1">
            <v-list v-if="planosDisponiblesParaRegion.length > 0" class="py-0">
              <v-list-item
                v-for="plano in planosDisponiblesParaRegion"
                :key="plano.id"
                @click="seleccionarPlanoParaRegion(plano)"
                class="border-bottom"
              >
                <v-list-item-content>
                  <v-list-item-title class="d-flex align-center">
                    <v-icon small class="mr-2" color="primary">mdi-floor-plan</v-icon>
                    <span class="font-weight-medium">{{ plano.nombre }}</span>
                  </v-list-item-title>
                  <v-list-item-subtitle v-if="plano.descripcion">
                    {{ plano.descripcion }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <div v-else class="pa-8 text-center grey--text">
              No hay subplanos disponibles.
            </div>
          </div>
        </v-card-text>
        </template>
      </v-card>
    </v-dialog>

    <!-- Diálogos hijos -->
    <DialogCrearSubnodo
      :dialog.sync="dialogCrearSubNodo"
      :tiposNodo="tiposNodo"
      :bannerTipoSeleccionado="bannerTipoSeleccionado"
      @save-subnode="crearSubnodo"
    />

    <AdjuntosLista
      v-if="clickedRegion"
      :dialog="dialogAdjuntos"
      @close="closeAdjuntos"
      @add-adjunto="$emit('add-adjunto', $event)"
      @refresh-adjuntos="clickedRegion && handleRegionClick(clickedRegion)"
      @error="$avisar($event, 'error')"
      @ver-en-plano="onVerEnPlano"
      @ver-en-arbol="onVerEnArbol"
      :adjuntos="adjuntos"
      :region="clickedRegion"
      :puedeEditar="puedeEditarArmarios"
      :puedeAdjuntar="permisos.includes('anadir-archivo')"
      :puedeEliminar="permisos.includes('eliminar-archivo')"
    />

    <v-snackbar
      v-model="snackbar"
      :timeout="3000"
      top
      centered
      rounded="pill"
      color="grey darken-3"
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="primary" text v-bind="attrs" @click="snackbar = false">OK</v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import axios from "axios";
import { urlBlobConSesion } from "@/plugins/axiosSesion";
// import VueDraggableResizable from "vue-draggable-resizable";
// import "vue-draggable-resizable/dist/VueDraggableResizable.css";
import { jwtDecode } from "jwt-decode";
import DialogCrearSubnodo from "./dialogs/DialogCrearSubnodo.vue";
import AdjuntosLista from "../utils/AdjuntosLista.vue";
import { mapState } from "vuex";
import { mapActions, mapGetters } from "vuex";
import Moveable from "vue-moveable"
import SimboloCategoria from "../utils/SimboloCategoria.vue";

// Tamaño (px) de los símbolos. Cada símbolo guarda el suyo en `ancho` (% del ancho del plano,
// como las regiones) con `alto` = 0; los colocados sin tamaño (ancho 0) usan el de por defecto.
const TAMANO_MIN = 12;
const TAMANO_MAX = 160;
const TAMANO_DEFECTO = 24;
const TAMANO_VISIBLE_MIN = 16;

// zoom del plano (1 = plano entero) y preferencia de mostrar los nombres
const ZOOM_MIN = 1;
const ZOOM_MAX = 8;
const PASO_ZOOM = 1.25;
const CLAVE_NOMBRES = "planos.mostrarNombres";

function leerPreferencia(clave) {
  try {
    return localStorage.getItem(clave) === "1";
  } catch (e) {
    return false;
  }
}

/** #RRGGBB + opacidad (0-1) en formato rgba() */
function rgba(hex, opacidad) {
  const m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})/i.exec(hex || "");
  if (!m) return null;
  return `rgba(${parseInt(m[1], 16)}, ${parseInt(m[2], 16)}, ${parseInt(m[3], 16)}, ${opacidad})`;
}

export default {
  components: {
    DialogCrearSubnodo,
    AdjuntosLista,
    Moveable,
    SimboloCategoria,
  },
  props: {
    nodo: Object,
    selectedPlano: { type: Object, default: null },
    armarios: { type: Array, default: () => [] },
    soloPlanos: { type: Boolean, default: false },
    planos: { type: Array, default: () => [] },
  },
  data() {
    return {
      ro: null,
      regiones: [],
      regionesPlano: [],
      clickedRegion: null,
      // al colocar un armario: true = símbolo de su categoría, false = región dibujada
      nuevoComoSimbolo: false,
      // armario elegido en el diálogo, a falta de decidir si va como región o como símbolo
      armarioPendiente: null,
      // arrastre de un símbolo en curso: { id, tipo: 'mover' | 'tamano', x0, y0, t0, inicioX, inicioY, movido }
      arrastreMarcador: null,
      // tras soltar un arrastre el navegador lanza un click que no debe abrir nada
      ignorarClick: false,
      dialogAdjuntos: false,
      modo: 1, // 1 = visualización, 2 = edición
      modoCrear: false,
      containerReady: false,

      imagenAncho: 0,
      imagenAlto: 0,
      anchoImagen: 0,
      altoImagen: 0,

      offsetX: 0,
      offsetY: 0,
      // plano entero ajustado al lienzo (zoom 1); el zoom y el desplazamiento se aplican encima
      base: { ancho: 0, alto: 0, x: 0, y: 0 },
      zoom: 1,
      panX: 0,
      panY: 0,
      ZOOM_MIN,
      ZOOM_MAX,
      PASO_ZOOM,
      altoLienzo: 480,
      paneo: null, // { x0, y0, panX0, panY0, movido }
      punteros: {}, // dedos sobre el lienzo (para pellizcar)
      pellizco: null, // { distancia }
      // vista
      mostrarNombres: leerPreferencia(CLAVE_NOMBRES),
      categoriasOcultas: [],
      leyendaAbierta: true,
      buscadorAbierto: false,
      resaltada: null,
      regionesCargadas: false,
      regionEditando: null,
      moveableTarget: null,
      estaRotando: false,
      moveableDragging: false,
      moveableFrame: {
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        rotate: 0,
      },
      moveableStartFrame: null,

      snackbar: false,
      snackbarText: "",

      idCliente: null,
      baseUrl: `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs`,
      // imagen del plano descargada con la sesión (URL blob:); <img>/CSS no envían el token
      imagenParaMostrar: null,

      tabDestinoRegion: 0,
      armarioSeleccionadoParaRegion: null,
      planoSeleccionadoParaRegion: null,
      dialogSeleccionarArmario: false,
      armariosAplanados: [],
      tiposNodo: [],
      dialogCrearSubNodo: false,
      subnodoForm: {
        parent_id: null,
        name: "",
        tipo: "",
      },
      nuevoArmario: "",
      creandoArmarioRaiz: false,
      adjuntos: [],
    };
  },
  computed: {
    ...mapState(["usuarios", "permisos"]),
    // crear/editar planos y sus regiones
    puedeEditarPlanos() {
      return (this.permisos || []).includes("editar-planos");
    },
    puedeEditarArmarios() {
      return (this.permisos || []).includes("editar-armarios");
    },
    ...mapState("armarios", ["regionSeleccionada", "regionNueva", "categorias"]),
    ...mapGetters("armarios", ["categoriaDeArmario"]),
    // armarios con región (rectángulo) y armarios marcados solo con un símbolo (sin tamaño)
    regionesArmario() {
      return this.regiones.filter((r) => !this.esMarcador(r));
    },
    marcadores() {
      return this.regiones.filter((r) => this.esMarcador(r));
    },
    xs() {
      return this.$vuetify.breakpoint.xs;
    },
    // categorías de los armarios del plano (regiones y símbolos) y cuántos hay de cada una
    leyenda() {
      const items = new Map();
      for (const r of this.regiones) {
        const cat = this.categoriaDe(r);
        const clave = this.claveCategoria(r);
        if (!items.has(clave)) {
          items.set(clave, cat
            ? { clave, nombre: cat.nombre, icono: cat.icono, color: cat.color, cuenta: 0 }
            : { clave, nombre: "Sin categoría", icono: null, color: undefined, cuenta: 0 });
        }
        items.get(clave).cuenta++;
      }
      return [...items.values()].sort((a, b) => (a.clave === "sin") - (b.clave === "sin") || a.nombre.localeCompare(b.nombre, "es"));
    },
    planoVacio() {
      return this.containerReady && this.regionesCargadas && !this.regiones.length && !this.regionesPlano.length && !this.modoCrear && this.modo === 1;
    },
    regionesArmarioVisibles() {
      return this.regionesArmario.filter((r) => !this.categoriasOcultas.includes(this.claveCategoria(r)));
    },
    marcadoresVisibles() {
      return this.marcadores.filter((r) => !this.categoriasOcultas.includes(this.claveCategoria(r)));
    },
    // lo que se puede buscar en el plano
    elementosPlano() {
      const lista = [
        ...this.regiones.map((r) => ({ clave: this.getRegionKey(r), nombre: r.name || "(sin nombre)", tipo: "armario" })),
        ...this.regionesPlano.map((r) => ({ clave: this.getRegionKey(r), nombre: r.nombre || "(sin nombre)", tipo: "plano" })),
      ];
      return lista.sort((a, b) => a.nombre.localeCompare(b.nombre, "es", { numeric: true }));
    },
    estiloLienzo() {
      return {
        height: `${this.altoLienzo}px`,
        backgroundImage: `url(${this.imagenParaMostrar})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: `${this.anchoImagen}px ${this.altoImagen}px`,
        backgroundPosition: `${this.offsetX}px ${this.offsetY}px`,
      };
    },
     regionSeleccionadaId() {
      // si es objeto -> intenta id / id_armario; si es número/string -> úsalo tal cual
      if (!this.regionSeleccionada) return null;
      if (typeof this.regionSeleccionada === "object") {
        return this.regionSeleccionada.id ?? this.regionSeleccionada.id_armario ?? null;
      }
      return this.regionSeleccionada;
    },

    hayRegionSeleccionada() {
      return this.regionSeleccionadaId !== null && this.regionSeleccionadaId !== undefined;
    },
    bannerTipoSeleccionado() {
      const tipo = this.tiposNodo.find((t) => t.id === this.nuevoTipoSeleccionado);
      if (tipo && tipo.banner_url) {
        return `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs${tipo.banner_url}`;
      }
      return null;
    },
    hayPlanoSeleccionado() {
      return (this.selectedPlano && Object.keys(this.selectedPlano).length > 0);
    },
    // URL de la imagen del plano en la API (se descarga con la sesión en cargarImagenPlano)
    urlImagenPlano() {
      if (this.selectedPlano?.ruta_archivo) {
        const ruta = this.selectedPlano.ruta_archivo.startsWith("/")
          ? this.selectedPlano.ruta_archivo
          : "/" + this.selectedPlano.ruta_archivo;
        return this.baseUrl + ruta+`?id_cliente=${localStorage.getItem('clienteSeleccionado')}`;
      }
      return null;
    },
    planosDisponiblesParaRegion() {
      return (this.planos || []).filter(
        (plano) => String(plano.id) !== String(this.selectedPlano?.id)
      );
    },
  },
  watch: {
    // selectedPlano: {
    //   immediate: true,
    //   async handler(newPlano) {
    //     if (newPlano && newPlano.id) {
    //       await this.cargarRegionesDesdeAPI();

    //       // Muy importante: una vez cargadas regiones + DOM, recalcula offsets
    //       this.$nextTick(() => this.calcularOffsets());
    //     } else {
    //       this.regiones = [];
    //     }
    //   },
    // },
    selectedPlano: {
      immediate: true,
      async handler(newPlano) {
        this.zoom = 1;
        this.panX = 0;
        this.panY = 0;
        this.categoriasOcultas = [];
        this.regionesCargadas = false;
        if (newPlano && newPlano.id) {
          await this.cargarRegionesDesdeAPI();
          
          // FORZAR LLAMADA AQUÍ:
          if (this.imagenParaMostrar) {
            this.cargarImagenDimensiones(this.imagenParaMostrar);
          }

          this.$nextTick(() => this.calcularOffsets());
        } else {
          this.regiones = [];
          this.regionesPlano = [];
        }
      },
    },
    armarios: {
      immediate: true,
      handler(nuevosArmarios) {
        this.armariosAplanados = Array.isArray(nuevosArmarios)
          ? this.aplanarArmarios(nuevosArmarios)
          : [];
      },
    },
    urlImagenPlano: {
      immediate: true,
      handler(url) {
        this.cargarImagenPlano(url);
      },
    },
    imagenParaMostrar(newVal) {
      if (newVal) {
        this.cargarImagenDimensiones(newVal);
      } else {
        this.imagenAncho = 0;
        this.imagenAlto = 0;
        this.containerReady = false;
      }
    },
  },
  async mounted() {
    this.idCliente = localStorage.getItem("clienteSeleccionado")
      ? localStorage.getItem("clienteSeleccionado")
      : jwtDecode(localStorage.getItem("token"))?.id_cliente || 1;

    window.addEventListener("resize", this.calcularOffsets);
    this.leyendaAbierta = !this.$vuetify.breakpoint.xs;
    if (this.soloPlanos && !this.categorias.length) this.fetchCategorias();
    await this.fetchTiposNodo();

    this.$nextTick(() => {
      const el = this.$refs.planoContainer;
      if (!el) return;

      this.ro = new ResizeObserver(() => {
        if (this.imagenParaMostrar && this.imagenAncho && this.imagenAlto) {
          this.calcularOffsets();
        }
      });
      this.ro.observe(el);
    });

    if(this.regionNueva) {
      this.seleccionarArmarioParaRegion(this.regionNueva);
    }

  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calcularOffsets);
    this.terminarPaneo();
    this.terminarArrastreMarcador(false);
    if (this.ro) this.ro.disconnect();
    if (this.imagenParaMostrar) URL.revokeObjectURL(this.imagenParaMostrar);
  },
  methods: {
    async cargarImagenPlano(url) {
      const anterior = this.imagenParaMostrar;
      let nueva = null;
      if (url) {
        try {
          nueva = await urlBlobConSesion(url);
        } catch (error) {
          console.error("Error al cargar la imagen del plano:", error);
        }
        // si mientras tanto se ha cambiado de plano, esta imagen ya no vale
        if (url !== this.urlImagenPlano) {
          if (nueva) URL.revokeObjectURL(nueva);
          return;
        }
      }
      this.imagenParaMostrar = nueva;
      if (anterior) URL.revokeObjectURL(anterior);
    },
    ...mapActions("armarios", ["setRegionNueva", "setCategorias"]),
    async fetchCategorias() {
      try {
        const { data } = await axios.get(
          `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/clientes/${this.idCliente}/categorias`
        );
        this.setCategorias(data);
      } catch (error) {
        console.error("Error al cargar categorías:", error);
      }
    },

    // ---- SÍMBOLOS ----
    esMarcador(region) {
      return region.tipo_region === "armario" && !(region.h > 0);
    },
    tamanoDe(m) {
      if (!(m.w > 0) || !this.anchoImagen) return TAMANO_DEFECTO;
      // escala con el plano, pero nunca tan pequeño que no se pueda pulsar (p. ej. en el móvil)
      return Math.round(Math.min(TAMANO_MAX * this.zoom, Math.max(TAMANO_VISIBLE_MIN, (m.w / 100) * this.anchoImagen)));
    },
    categoriaDe(marcador) {
      return this.categoriaDeArmario(marcador.id_armario || marcador.id);
    },
    // caja (px) del símbolo, centrada en su punto del plano
    getMarcadorPxBox(m) {
      const t = this.tamanoDe(m);
      return {
        left: (Number(m.x) / 100) * this.anchoImagen + this.offsetX - t / 2,
        top: (Number(m.y) / 100) * this.altoImagen + this.offsetY - t / 2,
        width: t,
        height: t,
        rotate: 0,
      };
    },
    getMarcadorStyle(m) {
      const { left, top, width, height } = this.getMarcadorPxBox(m);
      return { left: `${left}px`, top: `${top}px`, width: `${width}px`, height: `${height}px` };
    },
    // En "Editar regiones" los símbolos se arrastran directamente (sin seleccionarlos antes)
    // y el asa de la esquina cambia su tamaño. Fuera de edición un clic abre la documentación.
    iniciarArrastreMarcador(m, e, tipo = "mover") {
      if (this.modo !== 2 || !this.puedeEditarPlanos || this.modoCrear || e.button !== 0 || this.arrastreMarcador) return;
      this.arrastreMarcador = {
        id: m.id,
        tipo,
        x0: Number(m.x),
        y0: Number(m.y),
        t0: this.tamanoDe(m),
        inicioX: e.clientX,
        inicioY: e.clientY,
        movido: false,
      };
      window.addEventListener("pointermove", this.moverMarcador);
      window.addEventListener("pointerup", this.soltarMarcador);
      window.addEventListener("pointercancel", this.cancelarArrastreMarcador);
    },
    moverMarcador(e) {
      const a = this.arrastreMarcador;
      if (!a || !this.anchoImagen || !this.altoImagen) return;
      const dx = e.clientX - a.inicioX;
      const dy = e.clientY - a.inicioY;
      if (!a.movido && Math.hypot(dx, dy) < 4) return; // umbral para distinguirlo de un clic
      a.movido = true;
      e.preventDefault();

      const index = this.regiones.findIndex((r) => r.id === a.id);
      if (index === -1) return;
      if (a.tipo === "tamano") {
        // el símbolo está centrado: mover el asa d px hacia fuera lo agranda 2d
        const t = Math.min(TAMANO_MAX, Math.max(TAMANO_MIN, a.t0 + dx + dy));
        this.$set(this.regiones, index, { ...this.regiones[index], w: (t / this.anchoImagen) * 100 });
        return;
      }
      const limitar = (v) => Math.min(100, Math.max(0, v));
      this.$set(this.regiones, index, {
        ...this.regiones[index],
        x: limitar(a.x0 + (dx / this.anchoImagen) * 100),
        y: limitar(a.y0 + (dy / this.altoImagen) * 100),
      });
    },
    soltarMarcador() {
      this.terminarArrastreMarcador(true);
    },
    cancelarArrastreMarcador() {
      this.terminarArrastreMarcador(false);
    },
    async terminarArrastreMarcador(guardar) {
      window.removeEventListener("pointermove", this.moverMarcador);
      window.removeEventListener("pointerup", this.soltarMarcador);
      window.removeEventListener("pointercancel", this.cancelarArrastreMarcador);
      const a = this.arrastreMarcador;
      this.arrastreMarcador = null;
      if (!a || !a.movido) return;

      this.ignorarClick = true;
      setTimeout(() => { this.ignorarClick = false; }, 0);

      const marcador = this.regiones.find((r) => r.id === a.id);
      if (!marcador) return;
      if (!guardar) {
        this.$set(this.regiones, this.regiones.indexOf(marcador), {
          ...marcador, x: a.x0, y: a.y0, w: (a.t0 / this.anchoImagen) * 100,
        });
        return;
      }
      await this.guardarRegion({ ...marcador, h: 0, rotation: 0 });
    },
    onMarcadorClick(m) {
      if (this.ignorarClick) return;
      if (this.modo === 2) return; // en edición se arrastran o se quitan con la ✕
      this.handleRegionClick(m);
    },
    onVerEnArbol(region) {
      this.closeAdjuntos();
      this.$emit("ver-en-arbol", {
        ...region,
        id: region.id_armario || region.id,
      });
    },
    onVerEnPlano(region) {
      this.closeAdjuntos();

      const payload = {
        ...region,
        id: region.id_armario || region.id,
      };

      this.$emit("ver-en-plano", payload);
    },
    fetchTiposNodo() {
      return axios
        .get(`${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/armarios/tipos`)
        .then((response) => {
          this.tiposNodo = response.data.tipos_armarios || [];
        })
        .catch((error) => {
          console.error("Error al cargar tipos de nodo:", error);
        });
    },

    // ---- CARGA DE REGIONES (FIX PRINCIPAL: normalizar strings -> number) ----
    async cargarRegionesDesdeAPI() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/armarios/plano/${this.selectedPlano.id}?id_cliente=${localStorage.getItem('clienteSeleccionado')}`
        );

        const responseRegionPlanos = await axios.get(
          `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/planos/plano/${this.selectedPlano.id}?id_cliente=${localStorage.getItem('clienteSeleccionado')}`
        );

        this.regiones = (response.data || []).map((r) =>
          this.normalizarRegion({ ...r, tipo_region: "armario" })
        );

        this.regionesPlano = (responseRegionPlanos.data || []).map((r) =>
          this.normalizarRegion({ ...r, tipo_region: "plano" })
        );
        this.regionesCargadas = true;


        this.$nextTick(() => this.calcularOffsets());
      } catch (error) {
        console.error("Error al cargar regiones:", error);
        this.regiones = [];
        this.regionesPlano = [];
        this.snackbarText = "Error al cargar regiones";
        this.snackbar = true;
      }
    },

    // ---- ARMARIOS ----
    aplanarArmarios(armarios, nivel = 0) {
      let resultado = [];
      for (const armario of armarios) {
        const children_count = armario.children?.length || 0;

        resultado.push({
          ...armario,
          nivel,
          children_count,
        });

        if (armario.children && armario.children.length > 0) {
          resultado = resultado.concat(this.aplanarArmarios(armario.children, nivel + 1));
        }
      }
      return resultado;
    },

    abrirDialogCrearSubNodo(armario) {
      this.subnodoForm = {
        parent_id: armario.id,
        name: "",
        tipo: this.tiposNodo[0]?.value || "",
      };
      this.dialogSeleccionarArmario = false;
      this.$nextTick(() => {
        this.dialogCrearSubNodo = true;
      });
    },

    abrirDialogoSeleccionArmario() {
      this.armarioPendiente = null;
      this.tabDestinoRegion = 0;
      this.creandoArmarioRaiz = false;
      this.dialogSeleccionarArmario = true;
    },

    // Elegido un armario, el diálogo pregunta si colocarlo como región o como símbolo
    seleccionarArmarioParaRegion(armario) {
      this.armarioPendiente = armario;
      this.creandoArmarioRaiz = false;
      this.dialogSeleccionarArmario = true;
    },

    prepararColocacion(armario, comoSimbolo) {
      this.nuevoComoSimbolo = comoSimbolo;
      this.armarioPendiente = null;
      this.armarioSeleccionadoParaRegion = armario;
      this.planoSeleccionadoParaRegion = null;
      this.modoCrear = true;
      this.dialogSeleccionarArmario = false;
      this.snackbarText = this.nuevoComoSimbolo
        ? `Armario "${armario.name}" seleccionado. Haz clic en el plano donde quieras colocar su símbolo.`
        : `Armario "${armario.name}" seleccionado. Haz clic en el plano para crear la región.`;
      this.snackbar = true;
    },

    onRotateStart() {
      this.estaRotando = true;
      if (!this.regionEditando) return;
      this.moveableStartFrame = { ...this.moveableFrame };
    },
    async onRotateEnd() {
      this.estaRotando = false;
      if (!this.regionEditando) return;
      await this.commitMoveableChanges();
    },
    onRotate(e) {
      if (!this.regionEditando || !this.moveableTarget) return;

      this.moveableFrame.rotate = Number(e.beforeRotate || 0);
      this.applyMoveableFrameToTarget();
    },
    async commitMoveableChanges() {
      if (!this.regionEditando || !this.moveableTarget) return;

      const lista =
        this.regionEditando.tipo_region === "plano" ? this.regionesPlano : this.regiones;

      const index = lista.findIndex((r) => r.id === this.regionEditando.id);
      if (index === -1) return;

      let leftPx = parseFloat(this.moveableTarget.style.left);
      let topPx = parseFloat(this.moveableTarget.style.top);
      let widthPx = parseFloat(this.moveableTarget.style.width);
      let heightPx = parseFloat(this.moveableTarget.style.height);

      if (!Number.isFinite(leftPx) || !Number.isFinite(topPx) ||
          !Number.isFinite(widthPx) || !Number.isFinite(heightPx)) {
        const fallback = this.getRegionPxBox(lista[index]);
        leftPx = Number.isFinite(leftPx) ? leftPx : fallback.left;
        topPx = Number.isFinite(topPx) ? topPx : fallback.top;
        widthPx = Number.isFinite(widthPx) ? widthPx : fallback.width;
        heightPx = Number.isFinite(heightPx) ? heightPx : fallback.height;
      }

      leftPx = Math.max(
        this.offsetX,
        Math.min(this.offsetX + this.anchoImagen - widthPx, leftPx)
      );

      topPx = Math.max(
        this.offsetY,
        Math.min(this.offsetY + this.altoImagen - heightPx, topPx)
      );

      const rotate =
        Number.isFinite(Number(this.moveableFrame.rotate))
          ? Number(this.moveableFrame.rotate)
          : this.extractRotationFromTransform(this.moveableTarget.style.transform);

      const regionActualizada = {
        ...lista[index],
        x: ((leftPx - this.offsetX) / this.anchoImagen) * 100,
        y: ((topPx - this.offsetY) / this.altoImagen) * 100,
        w: (widthPx / this.anchoImagen) * 100,
        h: (heightPx / this.altoImagen) * 100,
        rotation: rotate,
      };

      this.$set(lista, index, regionActualizada);
      this.regionEditando = regionActualizada;
      this.moveableFrame = {
        left: leftPx,
        top: topPx,
        width: widthPx,
        height: heightPx,
        rotate,
      };
      this.moveableStartFrame = null;

      await this.guardarRegion(regionActualizada);
    },
    onCanvasClick(event) {
      if (this.ignorarClick) return;
      if (this.modoCrear) {
        this.agregarRegion(event);
        return;
      }

      if (this.modo === 2) {
        this.regionEditando = null;
        this.moveableTarget = null;
        this.moveableDragging = false;
        this.moveableStartFrame = null;
        this.moveableFrame = {
          left: 0,
          top: 0,
          width: 0,
          height: 0,
          rotate: 0,
        };
      }
    },
    // getRegionTransformStyle(region) {
    //   return {
    //     transform: `rotate(${Number(region.rotation || 0)}deg)`,
    //     transformOrigin: "center center",
    //   };
    // },
    getRegionPxBox(region) {
      return {
        left: this.pxFromPct(region.x, "w") + this.offsetX,
        top: this.pxFromPct(region.y, "h") + this.offsetY,
        width: this.pxFromPct(region.w, "w"),
        height: this.pxFromPct(region.h, "h"),
        rotate: Number(region.rotation || 0),
      };
    },

    applyMoveableFrameToTarget() {
      if (!this.moveableTarget) return;

      const { left, top, width, height, rotate } = this.moveableFrame;

      this.moveableTarget.style.left = `${left}px`;
      this.moveableTarget.style.top = `${top}px`;
      this.moveableTarget.style.width = `${width}px`;
      this.moveableTarget.style.height = `${height}px`;
      this.moveableTarget.style.transform = `rotate(${rotate}deg)`;
      this.moveableTarget.style.transformOrigin = "50% 50%";
    },

    extractRotationFromTransform(transform) {
      if (!transform || transform === "none") return 0;
      const match = transform.match(/rotate\((-?\d+(\.\d+)?)deg\)/);
      return match ? parseFloat(match[1]) : 0;
    },
    // las regiones de armario llevan el color de su categoría (sin categoría, el azul de siempre)
    getRegionVisualStyle(region) {
      const color = this.categoriaDe(region)?.color;
      if (!color) return {};
      return {
        "--region-borde": color,
        "--region-fondo": rgba(color, 0.16),
        "--region-fondo-hover": rgba(color, 0.32),
      };
    },
    esRegionSeleccionada(region) {
      return (
        this.regionEditando &&
        this.getRegionKey(region) === this.getRegionKey(this.regionEditando)
      );
    },
    onMoveableDragStart() {
      if (!this.regionEditando) return;
      this.moveableDragging = true;
      this.moveableStartFrame = { ...this.moveableFrame };
    },
    onMoveableResizeStart(e) {
      if (!this.regionEditando || !this.moveableTarget) return;

      this.moveableStartFrame = { ...this.moveableFrame };

      if (e.setOrigin) {
        e.setOrigin(["50%", "50%"]);
      }

      if (e.dragStart) {
        e.dragStart.set([0, 0]);
      }
    },

    onMoveableDrag(e) {
      if (!this.regionEditando || !this.moveableTarget) return;

      const left = typeof e.left === "number"
        ? e.left
        : (this.moveableStartFrame?.left || 0) + (e.beforeTranslate?.[0] || 0);

      const top = typeof e.top === "number"
        ? e.top
        : (this.moveableStartFrame?.top || 0) + (e.beforeTranslate?.[1] || 0);

      this.moveableFrame.left = left;
      this.moveableFrame.top = top;

      this.applyMoveableFrameToTarget();
    },


    async onMoveableDragEnd() {
      if (!this.regionEditando) return;
      this.moveableDragging = false;
      await this.commitMoveableChanges();
    },
    onRegionClick(region) {
      if (this.modo === 2) {
        this.seleccionarRegionParaEditar(region);
        return;
      }

      this.handleRegionClick(region);
    },
    onMoveableResize(e) {
      if (!this.regionEditando || !this.moveableTarget) return;

      const width = Math.max(10, e.width);
      const height = Math.max(10, e.height);

      const [tx, ty] = e.drag?.beforeTranslate || [0, 0];

      this.moveableFrame.left = (this.moveableStartFrame?.left || 0) + tx;
      this.moveableFrame.top = (this.moveableStartFrame?.top || 0) + ty;
      this.moveableFrame.width = width;
      this.moveableFrame.height = height;

      this.applyMoveableFrameToTarget();
    },

    async onMoveableResizeEnd() {
      if (!this.regionEditando) return;
      await this.commitMoveableChanges();
    },
    getRegionBoxStyle(region) {
      return {
        position: "absolute",
        left: `${this.pxFromPct(region.x, "w") + this.offsetX}px`,
        top: `${this.pxFromPct(region.y, "h") + this.offsetY}px`,
        width: `${this.pxFromPct(region.w, "w")}px`,
        height: `${this.pxFromPct(region.h, "h")}px`,
        overflow: "visible",
        transform: `rotate(${Number(region.rotation || 0)}deg)`,
        transformOrigin: "50% 50%",
      };
    },


    iniciarCreacionArmarioRaiz() {
      this.creandoArmarioRaiz = true;
      this.nuevoArmario = "";
    },

    async crearArmarioRaiz() {
      if (!this.nuevoArmario.trim()) return;

      const newNode = {
        name: this.nuevoArmario,
        parent_id: null,
        x: 50,
        y: 250,
        expanded: true,
        children: [],
        id_cliente: this.idCliente,
        id_usuario: this.user?.id || JSON.parse(localStorage.getItem("user"))?.id,
      };

      try {
        await axios.post(`${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/armarios`, newNode);
        this.nuevoArmario = "";
        this.$emit("fetch");
      } catch (error) {
        console.error("Error al crear armario:", error);
      }
    },

    // ---- IMAGEN / OFFSETS ----
    // cargarImagenDimensiones(src) {
    //   const img = new Image();
    //   img.onload = () => {
    //     this.imagenAncho = img.width;
    //     this.imagenAlto = img.height;

    //     this.$nextTick(() => {
    //       this.calcularOffsets();
    //       this.containerReady = true;

    //       // Importantísimo: si las regiones ya estaban cargadas antes de que termine la imagen
    //       // recalculamos offsets de nuevo para que se posicionen bien
    //       this.$nextTick(() => this.calcularOffsets());
    //     });
    //   };
    //   img.onerror = () => {
    //     this.containerReady = false;
    //     console.error("Error cargando la imagen:", src);
    //   };
    //   img.src = src;
    // },

    cargarImagenDimensiones(src) {
      this.containerReady = false; // Resetear siempre al cambiar de plano
      const img = new Image();

      img.onload = () => {
        this.imagenAncho = img.width;
        this.imagenAlto = img.height;
        
        this.$nextTick(() => {
          this.calcularOffsets();
          this.containerReady = true; // <--- Ahora sí entrará aquí
        });
      };

      img.onerror = () => {
        console.error("Error al cargar la ruta:", src);
        this.containerReady = false;
      };

      img.src = src;

      // SOLUCIÓN PARA CACHÉ: Si la imagen ya cargó, forzamos el disparo manual
      if (img.complete) {
        img.onload();
      }
    },
    // El lienzo ocupa el alto que queda en la ventana; el plano entero se ajusta dentro (zoom 1)
    calcularOffsets() {
      const contenedor = this.$refs.planoContainer;
      if (!contenedor) return;

      const margen = this.xs ? 8 : 20;
      const alto = Math.max(320, Math.round(window.innerHeight - contenedor.getBoundingClientRect().top - margen));
      if (Math.abs(alto - this.altoLienzo) > 1) {
        this.altoLienzo = alto;
        this.$nextTick(() => this.calcularOffsets());
        return;
      }
      if (!this.imagenAncho || !this.imagenAlto) return;

      const ancho = contenedor.clientWidth;
      const altoC = contenedor.clientHeight;
      if (!ancho || !altoC) return;

      const imgRatio = this.imagenAncho / this.imagenAlto;
      const base = imgRatio > ancho / altoC
        ? { ancho, alto: ancho / imgRatio }
        : { ancho: altoC * imgRatio, alto: altoC };
      base.x = (ancho - base.ancho) / 2;
      base.y = (altoC - base.alto) / 2;
      this.base = base;
      this.aplicarVista();
    },

    /** Tamaño y posición del plano en pantalla según el zoom y el desplazamiento */
    aplicarVista() {
      const contenedor = this.$refs.planoContainer;
      if (!contenedor || !this.base.ancho) return;
      const W = contenedor.clientWidth;
      const H = contenedor.clientHeight;
      const ancho = this.base.ancho * this.zoom;
      const alto = this.base.alto * this.zoom;
      // si el plano es más grande que el lienzo no se deja que aparezca hueco por los lados
      const limitar = (pos, tam, total) => (tam <= total ? (total - tam) / 2 : Math.min(0, Math.max(total - tam, pos)));
      const x = limitar(this.base.x + this.panX, ancho, W);
      const y = limitar(this.base.y + this.panY, alto, H);

      this.anchoImagen = ancho;
      this.altoImagen = alto;
      this.offsetX = x;
      this.offsetY = y;
      this.panX = x - this.base.x;
      this.panY = y - this.base.y;

      // la región en edición sigue a la vista
      if (this.regionEditando && this.moveableTarget && !this.esMarcador(this.regionEditando)) {
        this.moveableFrame = { ...this.getRegionPxBox(this.regionEditando) };
        this.$nextTick(() => this.$refs.moveable?.updateRect?.());
      }
    },

    /** Zoom manteniendo fijo el punto (px, py) del lienzo (por defecto, el centro) */
    zoomEn(factor, px, py) {
      const contenedor = this.$refs.planoContainer;
      if (!contenedor || !this.base.ancho) return;
      const z = Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, this.zoom * factor));
      if (z === this.zoom) return;
      const cx = px ?? contenedor.clientWidth / 2;
      const cy = py ?? contenedor.clientHeight / 2;
      const relX = (cx - this.offsetX) / this.anchoImagen;
      const relY = (cy - this.offsetY) / this.altoImagen;
      this.zoom = z;
      this.panX = cx - relX * this.base.ancho * z - this.base.x;
      this.panY = cy - relY * this.base.alto * z - this.base.y;
      this.aplicarVista();
    },
    reiniciarVista() {
      this.zoom = 1;
      this.panX = 0;
      this.panY = 0;
      this.aplicarVista();
    },
    onRueda(e) {
      const r = this.$refs.planoContainer.getBoundingClientRect();
      this.zoomEn(e.deltaY < 0 ? 1.15 : 1 / 1.15, e.clientX - r.left, e.clientY - r.top);
    },

    // Arrastrar el fondo mueve el plano; con dos dedos se hace zoom (pellizcar)
    iniciarPaneo(e) {
      if (e.pointerType === "mouse" && e.button !== 0) return;
      this.punteros = { ...this.punteros, [e.pointerId]: { x: e.clientX, y: e.clientY } };
      const dedos = Object.values(this.punteros);
      if (dedos.length === 2) {
        this.paneo = null;
        this.pellizco = { distancia: Math.hypot(dedos[0].x - dedos[1].x, dedos[0].y - dedos[1].y) };
      } else if (e.target === e.currentTarget && !this.modoCrear) {
        this.paneo = { x0: e.clientX, y0: e.clientY, panX0: this.panX, panY0: this.panY, movido: false };
      }
      window.addEventListener("pointermove", this.moverPaneo);
      window.addEventListener("pointerup", this.soltarPaneo);
      window.addEventListener("pointercancel", this.soltarPaneo);
    },
    moverPaneo(e) {
      if (!this.punteros[e.pointerId]) return;
      this.punteros = { ...this.punteros, [e.pointerId]: { x: e.clientX, y: e.clientY } };
      const dedos = Object.values(this.punteros);

      if (this.pellizco && dedos.length === 2) {
        const distancia = Math.hypot(dedos[0].x - dedos[1].x, dedos[0].y - dedos[1].y);
        const r = this.$refs.planoContainer.getBoundingClientRect();
        this.zoomEn(distancia / this.pellizco.distancia, (dedos[0].x + dedos[1].x) / 2 - r.left, (dedos[0].y + dedos[1].y) / 2 - r.top);
        this.pellizco.distancia = distancia;
        return;
      }
      const p = this.paneo;
      if (!p) return;
      const dx = e.clientX - p.x0;
      const dy = e.clientY - p.y0;
      if (!p.movido && Math.hypot(dx, dy) < 4) return;
      p.movido = true;
      this.panX = p.panX0 + dx;
      this.panY = p.panY0 + dy;
      this.aplicarVista();
    },
    soltarPaneo(e) {
      const { [e.pointerId]: _, ...resto } = this.punteros; // eslint-disable-line no-unused-vars
      this.punteros = resto;
      if (Object.keys(resto).length < 2) this.pellizco = null;
      if (Object.keys(resto).length === 0) this.terminarPaneo();
    },
    terminarPaneo() {
      window.removeEventListener("pointermove", this.moverPaneo);
      window.removeEventListener("pointerup", this.soltarPaneo);
      window.removeEventListener("pointercancel", this.soltarPaneo);
      if (this.paneo?.movido) {
        // el click que lanza el navegador al soltar no debe deseleccionar ni colocar nada
        this.ignorarClick = true;
        setTimeout(() => { this.ignorarClick = false; }, 0);
      }
      this.paneo = null;
      this.punteros = {};
      this.pellizco = null;
    },

    // ---- LEYENDA, NOMBRES Y BÚSQUEDA ----
    claveCategoria(region) {
      return this.categoriaDe(region)?.id ?? "sin";
    },
    alternarCategoria(clave) {
      this.categoriasOcultas = this.categoriasOcultas.includes(clave)
        ? this.categoriasOcultas.filter((c) => c !== clave)
        : [...this.categoriasOcultas, clave];
    },
    cambiarMostrarNombres() {
      this.mostrarNombres = !this.mostrarNombres;
      try {
        localStorage.setItem(CLAVE_NOMBRES, this.mostrarNombres ? "1" : "0");
      } catch (e) {
        /* sin localStorage: solo para esta sesión */
      }
    },
    /** Acerca la vista a un armario o subplano del plano y lo hace parpadear */
    enfocarElemento(clave) {
      if (!clave) return;
      const elemento = [...this.regiones, ...this.regionesPlano].find((r) => this.getRegionKey(r) === clave);
      const contenedor = this.$refs.planoContainer;
      this.buscadorAbierto = false;
      if (!elemento || !contenedor) return;

      // si su categoría está oculta, se vuelve a mostrar
      if (elemento.tipo_region === "armario") {
        const cat = this.claveCategoria(elemento);
        this.categoriasOcultas = this.categoriasOcultas.filter((c) => c !== cat);
      }
      const marcador = this.esMarcador(elemento);
      const cx = Number(elemento.x) + (marcador ? 0 : Number(elemento.w) / 2);
      const cy = Number(elemento.y) + (marcador ? 0 : Number(elemento.h) / 2);
      this.zoom = Math.max(this.zoom, 2.5);
      this.panX = contenedor.clientWidth / 2 - (cx / 100) * this.base.ancho * this.zoom - this.base.x;
      this.panY = contenedor.clientHeight / 2 - (cy / 100) * this.base.alto * this.zoom - this.base.y;
      this.aplicarVista();

      this.resaltada = clave;
      clearTimeout(this.temporizadorResaltado);
      this.temporizadorResaltado = setTimeout(() => { this.resaltada = null; }, 3500);
    },

    // FIX: convierte a Number y valida
    pxFromPct(value, type) {
      const num = Number(value);
      if (!Number.isFinite(num)) return 10;

      const size = type === "w" ? this.anchoImagen : this.altoImagen;
      if (!size || size <= 0) return 10;

      const px = Math.round((num / 100) * size);
      return Math.max(10, px);
    },

    // ---- REGIONES ----
    agregarRegion(e) {
      const contenedor = this.$refs.planoContainer;
      if (!contenedor || !this.containerReady) return;

      const rect = contenedor.getBoundingClientRect();
      let xRel = e.clientX - rect.left - this.offsetX;
      let yRel = e.clientY - rect.top - this.offsetY;

      xRel = Math.min(Math.max(0, xRel), this.anchoImagen);
      yRel = Math.min(Math.max(0, yRel), this.altoImagen);

      const esPlano = !!this.planoSeleccionadoParaRegion;
      const esSimbolo = this.nuevoComoSimbolo && !esPlano;

      // el símbolo se centra donde se hace clic; la región empieza en el clic con un tamaño inicial
      const wPx = esSimbolo ? TAMANO_DEFECTO : 120;
      const hPx = esSimbolo ? 0 : 80;

      const nuevaRegion = {
        id: Date.now(),
        x: (xRel / this.anchoImagen) * 100,
        y: (yRel / this.altoImagen) * 100,
        w: (wPx / this.anchoImagen) * 100,
        h: (hPx / this.altoImagen) * 100,
        rotation: 0,


        id_armario: esPlano ? null : this.armarioSeleccionadoParaRegion?.id || null,
        id_plano_hijo: esPlano ? this.planoSeleccionadoParaRegion?.id || null : null,

        tipo_region: esPlano ? "plano" : "armario",
      };

      if (esPlano){
        this.regionesPlano.push(nuevaRegion)
      }
      else{
        this.regiones.push(nuevaRegion);
      }

      this.modoCrear = false;
      this.nuevoComoSimbolo = false;
      this.armarioSeleccionadoParaRegion = null;
      this.planoSeleccionadoParaRegion = null;
      this.guardarRegion(nuevaRegion);
      this.setRegionNueva(null); // <--- Limpiar la región nueva después de crearla
      // la región se ajusta después en modo edición; el símbolo ya está colocado
      if (!esSimbolo) this.$nextTick(() => this.modo=2);
    },

    async guardarRegion(region) {
      if (!this.selectedPlano?.id || !region) return;

      try {
        const esNueva = !region.id || String(region.id).length >= 13; // Date.now() temporal

        if (esNueva) {
          if (region.tipo_region === "armario") {
            await axios.put(
              `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/planos/armario/${region.id_armario}`,
              {
                id_plano: this.selectedPlano.id,
                pos_x: region.x,
                pos_y: region.y,
                ancho: region.w,
                alto: region.h,
                rotation: region.rotation ?? 0,
                id_cliente: localStorage.getItem("clienteSeleccionado")
              }
            );
          } else if (region.tipo_region === "plano") {
            await axios.put(
              `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/planos/plano/${region.id_plano_hijo}`,
              {
                id_plano: this.selectedPlano.id,
                pos_x: region.x,
                pos_y: region.y,
                ancho: region.w,
                alto: region.h,
                rotation: region.rotation ?? 0,
              }
            );
          }
        } else {
          if (region.tipo_region === "armario") {
            await axios.put(
              `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/planos/mod/region`,
              {
                id_armario: region.id_armario || region.id,
                pos_x: region.x,
                pos_y: region.y,
                ancho: region.w,
                alto: region.h,
                rotation: region.rotation ?? 0,
              }
            );
          } else if (region.tipo_region === "plano") {
            await axios.put(
              `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/planos/mod/region-plano`,
              {
                id_plano: region.id_plano_hijo || region.id,
                pos_x: region.x,
                pos_y: region.y,
                ancho: region.w,
                alto: region.h,
                rotation: region.rotation ?? 0,
              }
            );
          }
        }

        await this.cargarRegionesDesdeAPI();

        this.snackbarText = "Cambios guardados";
        this.snackbar = true;
      } catch (error) {
        console.error("Error al guardar regiones:", error);
        this.snackbarText = "Error al guardar";
        this.snackbar = true;
      }
    },

    async eliminarRegion(region) {
      const esPlano = region.tipo_region === "plano";

      const ok = await this.$confirmar({
        titulo: "Quitar del plano",
        texto: `"${region.nombre || region.name || (esPlano ? "Este subplano" : "Este armario")}" dejará de estar en este plano. No se borra nada más.`,
        aceptar: "Quitar",
        peligro: true,
      });
      if (!ok) return;

      try {
        if (esPlano) {
          await axios.put(
            `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/planos/mod/region-plano`,
            {
              id_plano: region.id_plano_hijo || region.id,
              pos_x: null,
              pos_y: null,
              ancho: null,
              alto: null,
            }
          );
        } else {
          await axios.put(
            `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/planos/mod/region`,
            {
              id_armario: region.id_armario || region.id,
              pos_x: null,
              pos_y: null,
              ancho: null,
              alto: null,
            }
          );
        }

        await this.cargarRegionesDesdeAPI();

        this.snackbarText = "Región eliminada correctamente";
        this.snackbar = true;
        this.$emit("fetch");
      } catch (error) {
        console.error("Error al eliminar la región:", error);
        this.snackbarText = "No se pudo eliminar la región";
        this.snackbar = true;
      }
    },

    // ---- REGION ----
    handleRegionClick(region) {
      const destino = this.getRegionDestino(region);


      if (destino.tipo === "plano") {
        this.$emit("ir-a-subplano", {
          id: destino.id,
          region,
        });
        return;
      }

      if (destino.tipo === "armario") {
        axios
          .get(`${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/armarios/${destino.id}/adjuntos`,
            { params: { id_cliente: localStorage.getItem("clienteSeleccionado") } }
          )
          .then((response) => {
            this.clickedRegion = region;
            this.adjuntos = response.data.adjuntos;
            this.dialogAdjuntos = true;

            this.adjuntos.forEach((adjunto) => {
              adjunto.usuario = this.usuarios.find((u) => u.id === adjunto.id_usuario) || {
                // con portal externo (Quesos) el portal devuelve el nombre de quien lo subió
                username: (typeof adjunto.usuario === "string" && adjunto.usuario) || "Desconocido",
              };
            });
          })
          .catch((error) => {
            console.error("Error al obtener archivos adjuntos:", error);
          });

        return;
      }

      console.warn("La región no tiene destino válido", region);
    },

    closeAdjuntos() {
      this.adjuntos = [];
      this.clickedRegion = null;
      this.dialogAdjuntos = false;
    },

    normalizarRegion(region) {
      return {
        ...region,
        x: parseFloat(region.x ?? region.pos_x ?? 0),
        y: parseFloat(region.y ?? region.pos_y ?? 0),
        w: parseFloat(region.w ?? region.ancho ?? 0),
        h: parseFloat(region.h ?? region.alto ?? 0),
        rotation: parseFloat(region.rotation ?? 0),
        tipo_region: region.tipo_region || "armario",
      };
    },
    getRegionKey(region) {
      return `${region.tipo_region}-${region.id}`;
    },

    getRegionDestino(region) {
      const destino = region.tipo_region === "plano"
        ? {
            tipo: "plano",
            id: region.id,
          }
        : {
            tipo: "armario",
            id: region.id_armario || region.id,
          };

      return destino;
    },
    seleccionarRegionParaEditar(region) {
      if (this.modo !== 2) return;

      this.regionEditando = region;
      this.moveableDragging = false;

      const box = this.getRegionPxBox(region);
      this.moveableFrame = { ...box };
      this.moveableStartFrame = null;

      this.$nextTick(() => {
        const refName = `region-${this.getRegionKey(region)}`;
        const ref = this.$refs[refName];
        const rawRef = Array.isArray(ref) ? ref[0] : ref;
        const el = rawRef?.$el || rawRef;

        this.moveableTarget = el || null;

        if (this.moveableTarget) {
          this.applyMoveableFrameToTarget();
          this.$refs.moveable?.updateRect?.();
        }
      });
    },
    finalizarEdicion() {
      this.modo = 1;
      this.regionEditando = null;
      this.moveableTarget = null;
      this.moveableDragging = false;
      this.moveableStartFrame = null;
      this.estaRotando = false;
      this.moveableFrame = {
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        rotate: 0,
      };
    },
    seleccionarPlanoParaRegion(plano) {
      this.nuevoComoSimbolo = false;
      this.planoSeleccionadoParaRegion = plano;
      this.armarioSeleccionadoParaRegion = null;
      this.modoCrear = true;
      this.dialogSeleccionarArmario = false;
      this.snackbarText = `Subplano "${plano.nombre}" seleccionado. Haz clic en el plano para crear la región.`;
      this.snackbar = true;
    },

    // ---- SUBNODO DESDE PLANOS (lo dejo igual salvo que había un this.tiposSubnodo que no existe) ----
    async crearSubnodo(payload) {
      try {
        const { nombre, tipoSeleccionado, tipoNuevoTexto, tipoNuevoBanner } = payload;
        if (!nombre.trim()) {
          this.$avisar("Debes poner un nombre para el subnodo", "warning");
          return;
        }

        let tipoFinal = tipoSeleccionado;

        if (!tipoFinal && tipoNuevoTexto && tipoNuevoTexto.trim()) {
          try {
            if (tipoNuevoBanner) {
              const formData = new FormData();
              formData.append("name", tipoNuevoTexto.trim());
              formData.append("banner", tipoNuevoBanner);

              const res = await axios.post(
                `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/armarios/tipos`,
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
              );

              tipoFinal = res.data.id;

              // OJO: en tu código original usabas this.tiposSubnodo, pero NO existe en data()
              // Si quieres añadir el tipo a la lista, lo correcto sería:
              this.tiposNodo.push({
                id: tipoFinal,
                name: tipoNuevoTexto.trim(),
                id_cliente: this.idCliente,
                id_usuario: this.user?.id || JSON.parse(localStorage.getItem("user"))?.id,
                banner_url: res.data.banner_url,
              });
            } else {
              this.$avisar("Debes subir un banner para crear un nuevo tipo", "warning");
              return;
            }
          } catch (err) {
            this.$avisar("No se pudo crear el tipo nuevo", "error");
            console.error(err);
            return;
          }
        }

        if (!tipoFinal) {
          this.$avisar("Debes seleccionar o crear un tipo", "warning");
          return;
        }

        const payloadSubnodo = {
          name: nombre,
          id_parent: this.subnodoForm.parent_id,
          id_tipo: tipoFinal,
          x: null,
          y: null,
          id_cliente: this.idCliente,
          id_usuario: this.user?.id || JSON.parse(localStorage.getItem("user"))?.id,
          tipo: tipoFinal,
          expanded: true,
        };

        const res = await axios.post(
          `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/armarios`,
          payloadSubnodo
        );

        const armario = { id: res.data.id, name: nombre };
        this.seleccionarArmarioParaRegion(armario);

        this.dialogCrearSubNodo = false;
        this.$emit("fetch");
      } catch (e) {
        console.error("Error al crear Subnodo y región: ", e);
      }
    },
  },
};
</script>

<style scoped>
.plano-workspace {
  background-color: #f0f2f5 !important;
  position: relative;
  overflow: hidden;
}

.action-hud {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 5;
  flex-wrap: nowrap;
  background-color: rgba(255, 255, 255, 0.9) !important;
  backdrop-filter: blur(5px);
  max-width: fit-content;
  margin-left: auto !important;
  margin-right: auto !important;
}

.plano-viewport {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 20px;
}
.plano-viewport-movil {
  padding: 8px;
}

.plano-canvas {
  background-color: white;
  border-radius: 8px;
  position: relative;
  /* las capas de regiones y símbolos no se salen del plano (p. ej. por encima del menú lateral) */
  isolation: isolate;
  width: 100%;
  overflow: hidden;
  cursor: grab;
  /* el arrastre y el pellizco los gestiona el plano (zoom y desplazamiento) */
  touch-action: none;
  user-select: none;
}
/* deja sitio arriba para la barra de acciones flotante */
.plano-con-hud {
  padding-top: 0;
}
.plano-paneando {
  cursor: grabbing;
}

/* REGIONES */
.region-box {
  box-sizing: border-box;
  transition: box-shadow 0.3s ease;
  z-index: 10; /* FIX: asegura que se vean por encima */
  overflow: visible !important;
}

.region-view,
.region-edit {
  border-radius: 4px;
}

.region-view {
  cursor: pointer;
}

.region-edit {
  cursor: move;
}

.region-visual {
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  transition: transform 0.05s linear;
  border-radius: 4px;
}

/* ARMARIOS (con el color de su categoría si la tienen) */
.region-view.region-armario .region-visual {
  border: 2px solid var(--region-borde, #1976d2);
  background-color: var(--region-fondo, rgba(25, 118, 210, 0.15));
}

.region-view.region-armario:hover .region-visual {
  background-color: var(--region-fondo-hover, rgba(25, 118, 210, 0.3));
  box-shadow: 0 0 10px var(--region-fondo-hover, rgba(25, 118, 210, 0.5));
}

/* NOMBRES SIEMPRE VISIBLES */
.etiqueta-region,
.etiqueta-marcador {
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
  color: #263238;
  background: rgba(255, 255, 255, 0.88);
  border-radius: 4px;
  padding: 1px 5px;
  white-space: nowrap;
  pointer-events: none;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
}
.etiqueta-region {
  position: absolute;
  top: 2px;
  left: 2px;
  max-width: calc(100% - 4px);
  overflow: hidden;
  text-overflow: ellipsis;
}
.etiqueta-marcador {
  position: absolute;
  top: calc(100% + 3px);
  left: 50%;
  transform: translateX(-50%);
}

.region-edit.region-armario .region-visual {
  border: 2px dashed #fb8c00;
  background-color: rgba(251, 140, 0, 0.2);
}

.region-view.region-plano .region-visual {
  border: 2px solid #7e57c2;
  background-color: rgba(126, 87, 194, 0.16);
}

.region-view.region-plano:hover .region-visual {
  background-color: rgba(126, 87, 194, 0.28);
  box-shadow: 0 0 10px rgba(126, 87, 194, 0.45);
}

.region-edit.region-plano .region-visual {
  border: 2px dashed #7e57c2;
  background-color: rgba(126, 87, 194, 0.20);
}

/* ETIQUETA */
.region-label {
  position: absolute;
  top: -20px;
  left: 0;
  font-size: 10px;
  color: white;
  padding: 0 4px;
  border-radius: 2px;
  white-space: nowrap;
}

.region-armario .region-label {
  background: #fb8c00;
}

.region-plano .region-label {
  background: #7e57c2;
}

/* SÍMBOLOS */
.marcador {
  position: absolute;
  z-index: 11;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  transition: transform 0.15s ease;
}
.marcador:hover,
.marcador-arrastrando {
  transform: scale(1.25);
}
/* quien puede editar el plano los arrastra (también con el dedo) */
.marcador-movible {
  cursor: grab;
  touch-action: none;
}
.marcador-arrastrando {
  cursor: grabbing;
  z-index: 13;
  transition: none;
}
.marcador .delete-region-btn {
  top: -14px;
  right: -14px;
}

.plano-leyenda {
  position: absolute;
  bottom: 12px;
  left: 12px;
  z-index: 12;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 10px;
  max-width: min(260px, 55%);
  max-height: 45%;
  overflow-y: auto;
  padding: 4px;
  font-size: 0.75rem;
  color: #37474f;
  cursor: default;
}
.leyenda-cabecera {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 4px 6px;
  font-weight: 700;
  font-size: 0.7rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #546e7a;
}
.leyenda-ocultas {
  margin-left: 4px;
  font-weight: 500;
  text-transform: none;
  color: #fb8c00;
}
.leyenda-item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 3px 6px;
  border-radius: 6px;
  text-align: left;
  transition: background-color 0.15s ease, opacity 0.15s ease;
}
.leyenda-item:hover {
  background: #eef3f6;
}
.leyenda-nombre {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.leyenda-cuenta {
  margin-left: 8px;
  color: #90a4ae;
  font-weight: 600;
}
.leyenda-oculta {
  opacity: 0.4;
}
.leyenda-oculta .leyenda-nombre {
  text-decoration: line-through;
}
.leyenda-mostrar-todo {
  width: 100%;
  padding: 4px 6px;
  font-weight: 600;
  color: #117f9c;
  text-align: left;
}

.plano-vacio {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 12;
  max-width: 300px;
  padding: 20px 24px;
  text-align: center;
  background: rgba(255, 255, 255, 0.96);
  border-radius: 12px;
  color: #37474f;
  cursor: default;
}

.plano-controles {
  position: absolute;
  bottom: 12px;
  right: 12px;
  z-index: 12;
  display: flex;
  align-items: center;
  padding: 2px 4px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.95);
  cursor: default;
}
.separador-controles {
  width: 1px;
  height: 18px;
  margin: 0 4px;
  background: #e0e4e9;
}
.zoom-valor {
  min-width: 40px;
  text-align: center;
  font-size: 0.75rem;
  font-weight: 600;
  color: #546e7a;
}
.asa-tamano {
  position: absolute;
  right: -10px;
  bottom: -10px;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.35);
  cursor: nwse-resize;
  touch-action: none;
}

.opcion-colocar {
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}
.opcion-colocar:hover {
  border-color: #117f9c !important;
  background: rgba(17, 127, 156, 0.05);
}
.simbolo-opcion {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.region-pulse {
  animation: pulse-halo 1s ease-in-out infinite;
}
.region-selected {
  outline: 2px solid #00bcd4;
  outline-offset: 3px;
}

/* más potente: halo + glow */
@keyframes pulse-halo {
  0% {
    box-shadow: 0 0 0 0 rgba(25,118,210,.0), 0 0 0 0 rgba(25,118,210,.0);
  }
  40% {
    box-shadow: 0 0 0 10px rgba(25,118,210,.45), 0 0 18px 6px rgba(25,118,210,.45);
  }
  100% {
    box-shadow: 0 0 0 18px rgba(25,118,210,.0), 0 0 0 0 rgba(25,118,210,.0);
  }
}

.hud-movil {
  margin: 12px 12px 0 !important;
  max-width: calc(100% - 24px) !important;
}
.hud-titulo {
  min-width: 0;
  flex: 0 1 auto;
}
.hud-movil .hud-titulo .text-truncate {
  max-width: 38vw;
}
.boton-hud-movil {
  width: 32px !important;
  height: 32px !important;
}

.hierarchy-line {
  width: 15px;
  height: 1px;
  background-color: #e0e0e0;
  margin-right: 5px;
}

.border-bottom {
  border-bottom: 1px solid #f0f0f0;
}

.delete-region-btn {
  position: absolute;
  top: -12px;
  right: -12px;
  z-index: 20;
  background-color: white !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
</style>